export enum AssistantType {
  SCHEDULER = "SCHEDULER",
  BILLER = "BILLER",
  NOTE_TAKER = "NOTE_TAKER",
  SCRIBE_TASK_SUGGESTER = "SCRIBE_TASK_SUGGESTER",
  CALL_SUMMARIZER = "CALL_SUMMARIZER",
  FORM_SENDER = "FORM_ASSISTANT",
  INBOUND_CALL = "INBOUND_CALL",
  CALL_REMINDER = "CALL_REMINDER",
  CALL_FOLLOW_UP = "CALL_FOLLOW_UP",
  CALL_LAB_TECHNICIAN = "CALL_LAB_TECHNICIAN",
  OUTBOUND_CALL = "OUTBOUND_CALL",
  INBOUND_TEXT = "INBOUND_TEXT",
  WEB_CHAT = "WEB_CHAT",
}
